import printJS from "print-js";
import { api_URL } from "./Constantes";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";

export const printdocpdf = (numdoc) => {
  const userId = localStorage.getItem('login');
  const username = localStorage.getItem('username');
  const url = `${api_URL}Print/Document/${numdoc}`;

  fetch(url, {
    method: 'GET',
    headers: {
      'user_id': userId,
      'username': username,
    },
  })
    .then(response => response.blob())
    .then(blob => {
      const file = new Blob([blob], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // Utilisez printJS pour imprimer le PDF
      printJS(fileURL);
    })
    .catch(error => console.error('Erreur lors de la récupération du PDF', error));
};

export const printdocpdf2up = async (numdoc) => {
  const userId = localStorage.getItem('login');
  const username = localStorage.getItem('username');
  const url = `${api_URL}Print/Document/${numdoc}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'user_id': userId,
        'username': username,
      },
    });

    const arrayBuffer = await response.arrayBuffer();

    // Charger le PDF source (Jasper génère 2 pages : original + copie fournisseur)
    const srcPdf = await PDFDocument.load(arrayBuffer);
    const srcPages = srcPdf.getPages();
    const page1 = srcPages[0];
    const page2 = srcPages[1] ?? srcPages[0]; // fallback si une seule page
    const { width: srcWidth, height: srcHeight } = page1.getSize();

    // Page A4 paysage (en points : 841.89 x 595.28)
    const A4_W = 841.89;
    const A4_H = 595.28;
    const halfW = A4_W / 2;

    // Facteur d'échelle pour faire tenir chaque copie dans sa moitié
    const scale = Math.min(halfW / srcWidth, A4_H / srcHeight);
    const copyW = srcWidth * scale;
    const copyH = srcHeight * scale;

    // Centrage vertical de chaque copie
    const yOffset = (A4_H - copyH) / 2;

    const newPdf = await PDFDocument.create();
    const newPage = newPdf.addPage([A4_W, A4_H]);

    // Embarquer les 2 pages Jasper
    const [embeddedLeft, embeddedRight] = await newPdf.embedPages([page1, page2]);

    // Page 1 (Original à facturer) à gauche
    newPage.drawPage(embeddedLeft, { x: 0, y: yOffset, width: copyW, height: copyH });

    // Page 2 (Copie Fournisseur) à droite
    newPage.drawPage(embeddedRight, { x: halfW, y: yOffset, width: copyW, height: copyH });

    // ── Ligne de découpe verticale au centre ─────────────────────────────────
    const font = await newPdf.embedFont(StandardFonts.Helvetica);
    const separatorX = halfW;
    const dashLen = 6;
    const gapLen = 4;
    const lineColor = rgb(0.5, 0.5, 0.5);

    // Tirets verticaux
    let y = A4_H;
    while (y > 0) {
      const segEnd = Math.max(y - dashLen, 0);
      newPage.drawLine({
        start: { x: separatorX, y },
        end: { x: separatorX, y: segEnd },
        thickness: 0.5,
        color: lineColor,
      });
      y -= dashLen + gapLen;
    }

    // Libellé "couper ici" centré verticalement, pivoté de 90°
    const label = '- couper ici -';
    const fontSize = 7;
    newPage.drawText(label, {
      x: separatorX + fontSize / 2,
      y: A4_H / 2 - (label.length * fontSize * 0.3) / 2,
      size: fontSize,
      font,
      color: lineColor,
      rotate: { type: 'degrees', angle: 90 },
    });
    // ─────────────────────────────────────────────────────────────────────────

    const pdfBytes = await newPdf.save();
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(blob);

    // Lancer l'impression via printJS
    printJS({
      printable: fileURL,
      documentTitle: 'Document',
      modalMessage: "Préparation de l'impression...",
      type: 'pdf',
    });
  } catch (error) {
    console.error('Erreur lors de la génération du PDF 2 en 1', error);
  }
};
